import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AbstractDialogComponent, DialogNgbService } from '@motivforce/mx-library-angular';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { filter, map } from 'rxjs';
import { SupportRequestType } from 'src/app/core/enum/support-request-type.enum';
import { SupportStoreService } from 'src/app/core/store/support-store.service';

@Component({
  selector: 'app-missing-invoice-dialog',
  templateUrl: './missing-invoice-dialog.component.html',
  styleUrls: ['./missing-invoice-dialog.component.scss'],
})
export class MissingInvoiceDialogComponent extends AbstractDialogComponent implements OnInit {
  businessGroups$ = this.supportStore.businessGroups$.pipe(
    filter(Boolean),
    map((buisnessGroups) => buisnessGroups.map((businessGroup) => ({ key: businessGroup, value: businessGroup })))
  );

  formGroup: UntypedFormGroup = this.formBuilder.group({
    invoiceNumber: [null, [Validators.required]],
    invoiceDate: [null, [Validators.required]],
    customerName: [null, [Validators.required]],
    quantityOfUnits: [null, [Validators.required, Validators.pattern('^[0-9]*')]],
    productNumber: [null, [Validators.required]],
    businessGroup: [null],
  });

  invoiceFile: File | null;
  promotionName: string | null = null;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public activeModal: NgbActiveModal,
    private supportStore: SupportStoreService,
    private dialog: DialogNgbService,
    private translate: TranslateService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.inputs && this.inputs.length > 0) {
      this.promotionName = this.inputs[0];
    }
    this.supportStore.getBusinessGroups();
  }

  onSubmit(): void {
    if (this.formGroup.valid) {
      const formData = this.generateFormData();
      this.supportStore.sendSupportRequest(SupportRequestType.MISSING_INVOICE, formData).then((success) => {
        if (success) {
          this.dialog.openNotification(
            [this.translate.instant('A member of our Service Team will be in touch in 48 hours.')],
            this.translate.instant('Thank you for your query')
          );
          this.activeModal.close('submit');
        }
      });
    } else {
      this.dialog.openValidation(
        [this.translate.instant('Please make sure you have completed all required fields')],
        this.translate.instant('Important')
      );
    }
  }

  generateFormData(): FormData {
    const formData = new FormData();
    const formValue = { ...this.formGroup.value };
    formData.append('invoiceNumber', formValue.invoiceNumber);
    formData.append('invoiceDate', formValue.invoiceDate);
    formData.append('customerName', formValue.customerName);
    formData.append('quantityOfUnits', formValue.quantityOfUnits);
    formData.append('productNumber', formValue.productNumber);
    formData.append('businessGroup', formValue.businessGroup);

    if (this.promotionName) {
      formData.append('promotionName', this.promotionName);
    }

    if (this.invoiceFile) {
      formData.append('file', this.invoiceFile, this.invoiceFile.name);
    }

    return formData;
  }

  handleFileUpload(event: any) {
    this.invoiceFile = event.target.files[0] as File;
  }
}
